
import { ISpecificationTemplatesGetRequest } from "@/shared/services/interface/ISpecificationTemplate";
import { specificationTemplateServices } from "@/shared/services/specification-template-services";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getSpecificationTemplate = createAsyncThunk(
    'specificationTemplate/getSpecificationTemplate',
    async (templateId: string, { rejectWithValue }) => {
        try {
            const response = await specificationTemplateServices.getSpecificationTemplate(templateId);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const getSpecificationTemplates = createAsyncThunk(
    'specificationTemplate/getSpecificationTemplates',
    async (payload: ISpecificationTemplatesGetRequest, { rejectWithValue }) => {
        try {
            const response = await specificationTemplateServices.getSpecificationTemplates(payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)